// @flow

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PdbCompareComponent from './pdbCompare';
import {
  getPdbIds,
  shouldShowPopup,
  getIsCompareOpen,
  toggleCompareOpen,
} from '../../../store/pdbComparison';
import withPdbIdsFromStorage from '../withPdbIdsFromStorage';
import {
  getCarSelectedText,
  getCarsSelectedText,
  getButtonCompareCarsText,
  getComparePageLink,
} from '../../../store/compareSettings/selectors';
import { compareEnabled } from '../../../store/compareSettings';

type DispatchProps = {|
  onTogglePdbCompare: Function,
|};

type StateProps = {|
  isOpen: boolean,
  pdbIds: Array<string>,
  carSelectedText: string,
  carsSelectedText: string,
  buttonCompareCarsText: string,
  comparePageLink: string,
  shouldShow: boolean,
  isCompareEnabed: boolean,
|};

type Props = {|
  ...DispatchProps,
  ...StateProps,
|};

const PdbCompare = ({
  pdbIds,
  isOpen,
  onTogglePdbCompare,
  carSelectedText,
  carsSelectedText,
  buttonCompareCarsText,
  shouldShow,
  comparePageLink,
  isCompareEnabed,
}: Props) => (
  <>
    {isCompareEnabed && shouldShow && (
      <PdbCompareComponent
        pdbIds={pdbIds}
        isOpen={isOpen}
        onTogglePdbCompare={onTogglePdbCompare}
        carSelectedText={carSelectedText}
        carsSelectedText={carsSelectedText}
        buttonCompareCarsText={buttonCompareCarsText}
        comparePageLink={comparePageLink}
      />
    )}
  </>
);

const mapStateToProps = (state): StateProps => ({
  isOpen: getIsCompareOpen(state),
  pdbIds: getPdbIds(state),
  carSelectedText: getCarSelectedText(state),
  carsSelectedText: getCarsSelectedText(state),
  buttonCompareCarsText: getButtonCompareCarsText(state),
  comparePageLink: getComparePageLink(state),
  shouldShow: shouldShowPopup(state),
  isCompareEnabed: compareEnabled(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onTogglePdbCompare: () => dispatch(toggleCompareOpen()),
});

export default compose(
  connect<Props, any, StateProps, DispatchProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withPdbIdsFromStorage,
)(PdbCompare);
